import Flag from './Flag'

export default Flag
// eslint-disable-next-line import/export
export * from './Flag'
